import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  apidata,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  hubFilter,
  setHubFilter,
  statusFilter,
  setStatusFilter,
  companyFilter,
  setCompanyFilter,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="fromDate">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="toDate">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="vendorFilter">
            <Form.Label>Hub</Form.Label>
            <Form.Control
              as="select"
              value={hubFilter}
              onChange={(e) => setHubFilter(e.target.value)}
            >
              <option value="">All Hubs</option>

              {apidata &&
                Array.from(
                  new Set(
                    apidata.flatMap((item) =>
                      item.hubUsage?.map((hub) => hub.hubName)
                    )
                  )
                )
                  .filter(Boolean)
                  .map((hubName, index) => (
                    <option key={index} value={hubName}>
                      {hubName}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="companyFilter">
            <Form.Label>Company</Form.Label>
            <Form.Control
              as="select"
              value={companyFilter}
              onChange={(e) => setCompanyFilter(e.target.value)}
            >
              <option value="">Vehicle Company</option>
              {Array.from(new Set(apidata.map((item) => item.vehicleCompany)))
                .filter(Boolean)
                .map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="statusFilter">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="unassigned">Unassigned</option>'{" "}
              <option value="Service_Center">Service_Center</option>'
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
